import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable()
export class InfineScrollLoaderService {
    public scrollStatus: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    public currentStatusValue: Observable<any>;
    constructor() {
        this.currentStatusValue = this.scrollStatus.asObservable();
    }
    public display(value: boolean) {
        this.scrollStatus.next(value);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/infine-scroll-loader.service.ts